import { createSelector } from 'reselect';
import type { People } from './reducers';

const getPeopleState = (state) => {
  return state.people as Record<string, People>;
};

export const getPeople = createSelector([getPeopleState], (people) => people);
